import wAxios from '@/plugins/w/axios/models/axios'
import { createApiHook } from '@/plugins/app/api'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export const QUERY_KEY = 'dashboard'

export const fetchFn = async () => {
	return wAxios.get_auth_data(`v1/dashboard/all`)
		.catch((error) => Promise.reject(error.response || error))
}

const dashboardEnabled = () => {
	const route = useRoute()
	
	const pagesWithBadges = [
		'Dashboard',
	]
	return computed(() => pagesWithBadges.includes(route.name as string))
}

export const useDashboardApi = createApiHook(fetchFn, QUERY_KEY, undefined, {
	enabled: dashboardEnabled
})
